import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Alert,
  Container,
  Divider,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleEsqueciSenha = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Por favor, informe seu email.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();

      if (response.ok) {
        setMessage("Um link de redefinição foi enviado para o seu email.");
        setError("");
      } else {
        setError(data.message || "Erro ao solicitar redefinição de senha.");
      }
    } catch (error) {
      console.error("Erro ao solicitar redefinição de senha:", error);
      setError("Erro no servidor. Tente novamente.");
    }
  };

  return (
    <Container maxWidth="xs" style={styles.container}>
      <Box style={styles.box}>
        <EmailIcon fontSize="large" style={styles.icon} />
        <Typography variant="h5" align="center" style={styles.header}>
        Redefinição de Senha
        </Typography>
        <Typography variant="body2" align="center" style={styles.instructions}>
          Informe seu email para receber um link de redefinição de senha.
        </Typography>
        <Divider style={styles.divider} />
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <form onSubmit={handleEsqueciSenha}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
            style={styles.textField}
            inputProps={{ style: { backgroundColor: '#ffffffff', color: '#777777e0' } }}
          />
          <Button
            fullWidth
            variant="contained"
            style={styles.button}
            type="submit"
          >
            Enviar Link
          </Button>
        </form>
      </Box>
    </Container>
  );
}

const styles = {
  container: {
    marginTop: "50px",
    backgroundColor: "#ffffff", // Fundo branco
    color: "#000000ff", // Texto em cinza escuro
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)", // Sombra mais leve
  },
  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  icon: {
    color: "#2069b4", // Azul para destaque
    marginBottom: "10px",
  },
  header: {
    color: "#333",
    marginBottom: "10px",
    fontWeight: "bold",
  },
  instructions: {
    color: "#666",
    marginBottom: "20px",
  },
  divider: {
    width: "100%",
    backgroundColor: "#ddddddbb", // Cinza claro
    margin: "10px 0",
  },
  textField: {
  backgroundColor: "#ffffffff",
  borderRadius: "5px",
},


  button: {
    marginTop: "20px",
    backgroundColor: "#2069b4",
    color: "#fff",
    padding: "10px 20px",
    fontWeight: "bold",
    borderRadius: "5px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#185a90",
    },
  },
};

export default EsqueciSenha;
